import { Box } from '@mui/material'
import { colorTokens } from '../../../shared/styles/theme'

/**
 * サイドバー最上段のブランドマーク(02-components/sidebar.md WorkspaceRow)。
 *
 * 菱形を左右二面に割った**面取り**(ADR-0026)。色相は増やさず `fg.default` の
 * opacity 0.45 / 1.0 で組む。**面(背景)を持たない** — `bg.emphasis` は行 hover の地として
 * 意味が確定しており、静的な面に流用すると hover と区別がつかない。
 *
 * **記号文字(`◆`)では組まない**(ADR-0024)。字形・サイズ・垂直位置がフォント依存になる。
 * mamoru は文字サイズモードを持たないので辺は 13px 固定(kakeru は `label` 字送りに追従)。
 */
export const BrandMark = () => (
  <Box
    component="span"
    aria-hidden="true"
    sx={{
      width: 13,
      height: 13,
      flexShrink: 0,
      display: 'inline-flex',
      color: colorTokens.fg.default,
    }}
  >
    <svg width="100%" height="100%" viewBox="0 0 10 10" focusable="false">
      <path d="M5 0.6 L0.6 5 L5 9.4 Z" fill="currentColor" opacity="0.45" />
      <path d="M5 0.6 L9.4 5 L5 9.4 Z" fill="currentColor" />
    </svg>
  </Box>
)
